import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { brandOverride } from '../../../../../ECoSystemsHelper';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import {
  P00058SpeedDefaultValue,
  P00058SpeedEnum,
} from '../../Enum/P00058SpeedEnum';
import { P00058SpeedUnitEnum } from '../../Enum/P00058SpeedUnitEnum';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { SlideModalController } from '../../../../../../slide-modal.service';

@Component({
  selector: 'app-p00058-installation-pompe',
  templateUrl: './p00058-installation-pompe.component.html',
  styleUrls: ['./p00058-installation-pompe.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    TranslatePipe,
  ],
})
export class P00058InstallationPompeComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private translateService: TranslateService = inject(TranslateService);
  private slideModalController: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  constructor() {
    this.getSpeedUnitInformation = this.getSpeedUnitInformation.bind(this);
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  async getSpeedUnitInformation() {
    const modal = await this.slideModalController.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description:
          this.translateService.instant(
            'P00058.installation.pompe.speedUnit.enSavoirPlus',
          ) +
          ' ' +
          this.actionStack!.getValue('pvSVitesseMaxRpm') +
          this.translateService.instant(
            'P00058.installation.pompe.speedUnit.enSavoirPlus.rpm',
          ),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  getSpeedEnum(min: number, max: number) {
    return P00058SpeedEnum(
      this.translateService,
      this.actionStack!.getValue('pvPUniteConsignePompe'),
      this.actionStack!.getValue('pvSVitesseMaxRpm'),
      min,
      max,
      5,
      this.actionStack!.getValue('pvSVitesseMinRpm'),
      this.actionStack!.getValue('pvSVitesseMaxRpm'),
      100,
    );
  }

  onSpeedUnitChange(value: any) {
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPUniteConsignePompe',
      value,
      null,
    );

    // Sur un changement d'unité on va set chaque valeur par les valeurs par défault
    const defaultValues = P00058SpeedDefaultValue(
      this.actionStack!.getValue('pvSVitesseMaxRpm'),
    );
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPVitesseV1',
      defaultValues['35%'],
      null,
    );
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPVitesseV2',
      defaultValues['70%'],
      null,
    );
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPVitesseV3',
      defaultValues['100%'],
      null,
    );
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPVitesseEcremage',
      defaultValues['80%'],
      null,
    );
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPVitesseAmorcage',
      defaultValues['100%'],
      null,
    );
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Installation,
      'pvIConsignePompeDoconnexion',
      defaultValues['100%'],
      null,
    );
  }

  onSpeed1Change(value: any) {
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPVitesseV1',
      value,
      null,
    );
  }

  onSpeed2Change(value: any) {
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPVitesseV2',
      value,
      null,
    );
  }

  onSpeed3Change(value: any) {
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPVitesseV3',
      value,
      null,
    );
  }

  onSpeedDecoChange(value: any) {
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Installation,
      'pvIConsignePompeDoconnexion',
      value,
      null,
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly brandOverride = brandOverride;
  protected readonly P00058SpeedUnitEnum = P00058SpeedUnitEnum;
}
